/**
 * Persist Quick Buy browser events to the plugin REST beacon.
 */
import { getSettings } from '../config.js';

const TRACKED = [
	'wcQuickBuy:opened',
	'wcQuickBuy:optionsRequested',
	'wcQuickBuy:optionsLoaded',
	'wcQuickBuy:optionsFailed',
	'wcQuickBuy:variationSelected',
	'wcQuickBuy:addStarted',
	'wcQuickBuy:addSucceeded',
	'wcQuickBuy:addFailed',
	'wcQuickBuy:viewProductClicked',
	'wcQuickBuy:stockAlertRequested',
	'wcQuickBuy:unsupportedProduct',
];

export function initAnalyticsBeacon() {
	TRACKED.forEach((name) => {
		document.addEventListener(name, (event) => {
			send(name, event.detail || {});
		});
	});
}

function send(eventName, detail) {
	const settings = getSettings();
	if (!settings.restUrl) {
		return;
	}

	const body = JSON.stringify({
		event: eventName,
		...detail,
	});

	const headers = {
		'Content-Type': 'application/json',
		Accept: 'application/json',
	};
	if (settings.wpRestNonce) {
		headers['X-WP-Nonce'] = settings.wpRestNonce;
	}

	try {
		fetch(`${settings.restUrl}/events`, {
			method: 'POST',
			credentials: 'same-origin',
			headers,
			body,
			keepalive: true,
		});
	} catch (e) {
		// Beacon must never interrupt add-to-cart.
	}
}
